// extracted by mini-css-extract-plugin
module.exports = {"main":"TextImageCard_main__29ZOZ","card":"TextImageCard_card__5nc6C","content":"TextImageCard_content__DwkrP","image-container":"TextImageCard_image-container__mACsq"};